<template>
  <div class="info-section-tutorial-tile">
    <div class="info-section-tutorial-tile__icon">
      <img :src="props.icon">
      <v-divider
        class="info-section-tutorial-tile__divider"
        vertical
        opacity="1"
      />
    </div>
    <h3
      class="info-section-tutorial-tile__title"
      v-html="props.title"
    />
    <p
      v-orphans
      class="info-section-tutorial-tile__text"
    >
      {{ props.text }}
    </p>
    <a
      class="info-section-tutorial-tile__submit"
      :href="props.link"
      target="_blank"
    >
      <v-icon color="white">
        {{ props.submitIcon }}
      </v-icon>
    </a>
  </div>
</template>

<script setup lang="ts">
import Tutorial from '@/assets/images/infoSection/tutorial.png';

type Props = {
  title: string;
  text: string;
  icon?: string;
  submitIcon?: string;
  link: string;
}

const props = withDefaults(defineProps<Props>(), {
    icon: Tutorial,
    submitIcon: '$chevronRight'
});
</script>

<style lang="scss">
@use '@/assets/css/variables.scss' as variables;

.info-section-tutorial-tile {
  background-color: #fff;
  color: #000;
  display: grid;
  gap: 16px;
  grid-template-columns: auto 1fr auto;
  grid-template-areas:
    "icon title submit"
    "icon text submit";
  border: 2px solid #D9D9D9;

  &__icon {
    grid-area: icon;
    align-self: center;

    display: flex;
    align-items: center;
    margin-left: 8px;

    display: none;

    @media (min-width: map-get(variables.$grid-breakpoints, 'md')) {
      display: block;
    }
  }

  &__title {
    grid-area: title;
    font-weight: 500;
    margin-top: 16px
  }

  &__text {
    grid-area: text;
    margin-bottom: 16px;
  }

  &__submit {
    grid-area: submit;
    align-self: stretch;
    background-color: #ED1C24;

    display: flex;
    align-items: center;
    padding: 0 8px;
  }

  &__divider {
    height: 90px;
    padding: 0 8px;
    color: #D9D9D9;
  }

}
</style>
